import type {
  MessageBoxVariant,
  MessageBoxWidgetConfig,
  ResolvedMessageBoxDeviceConfig,
  WidgetDeviceType,
} from "@intelligems/ig-types";
import { merge } from "@intelligems/ig-utils";

export function getDefaultDeviceConfig(
  device: WidgetDeviceType,
  variant: MessageBoxVariant = "messageBoxPopupWidget1"
) {
  const config: ResolvedMessageBoxDeviceConfig = {
    device,
    variant,
    styles: {
      container: {
        textColor: "#494C50",
        backgroundColor: "#F1F1F1",
        cornerRadius: "5px",
      },
      typography: {
        title: {
          fontSize: "16px",
          fontStyle: "medium",
        },
        description: {
          fontSize: "14px",
          fontStyle: "regular",
        },
      },
      placement: "top-left",
    },
    variables: {
      textReplacements: {
        title: "",
        body: "",
      },
      image: "",
    },
  };
  switch (variant) {
    case "messageBoxSlideOutWidget1":
      break;
  }
  return config;
}

export function resolveDesktopMessageBoxConfig(config: MessageBoxWidgetConfig) {
  return merge(
    getDefaultDeviceConfig("desktop", config.desktop?.variant),
    config.desktop
  );
}

export function resolveMobileMessageBoxConfig(config: MessageBoxWidgetConfig) {
  return merge(
    getDefaultDeviceConfig(
      "mobile",
      config.mobile?.variant ?? config.desktop?.variant
    ),
    (merger) => {
      merger.merge(config.desktop);
      merger.merge(config.mobile);
    }
  );
}

export const resolveMessageBoxConfig = (config: MessageBoxWidgetConfig) => {
  return {
    desktop: resolveDesktopMessageBoxConfig(config),
    mobile: resolveMobileMessageBoxConfig(config),
  };
};
